// [2026-08-12] ADDED — InC-Proctor sign-in handoff.
//
// Holds a loading flag and the last error message. THE HANDOFF CODE IS DELIBERATELY NOT STORED:
// Redux state in this app is persisted to localStorage by redux-persist, and a credential — even
// a single-use one that expires in seconds — has no business being written to disk. The saga
// hands the code straight to the redirect and it is never held anywhere.

import {
  PROCTOR_HANDOFF,
  PROCTOR_HANDOFF_SUCCESS,
  PROCTOR_HANDOFF_FAILURE,
} from "../action/types";

const INIT_STATE = {
  loading: false,
  error: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROCTOR_HANDOFF:
      return { ...state, loading: true, error: "" };
    case PROCTOR_HANDOFF_SUCCESS:
      return { ...state, loading: false, error: "" };
    case PROCTOR_HANDOFF_FAILURE:
      return { ...state, loading: false, error: action.payload || "" };
    default:
      return state;
  }
};
